import type { AiCostLimitAlertPayload } from '@Application/AiCostLimits/Alerts/Actions/aiCostLimitAlertsFetched';
import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type { AiCostLimitState } from '@Domain/AiCostLimits/AiCostLimitState';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitAlertView {
	readonly limitId: number;
	readonly level: AiCostLimitLevel;
	readonly subjectId: number;
	readonly state: AiCostLimitState;
	readonly percent: number;

	constructor(payload: AiCostLimitAlertPayload) {
		this.limitId = payload.limitId;
		this.level = payload.level.value;
		this.subjectId = payload.subjectId;
		this.state = payload.state.value;
		this.percent = payload.percent;

		Object.freeze(this);
	}

	/** Read from the server's state, never recomputed: at or past the limit, no new processing starts. */
	get isBlocking(): boolean {
		return this.state === 'reached' || this.state === 'exceeded';
	}
}

export default AiCostLimitAlertView;
